import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BugContext } from 'features/feedback/shared/feedback.types';

const ROW: Array<[keyof BugContext, string]> = [
  ['route', 'Сторінка'], ['version', 'Версія'], ['browser', 'Браузер'],
  ['os', 'ОС'], ['locale', 'Мова'], ['viewport', 'Вікно'],
];

const ContextAccordion: React.FC<{ context: BugContext }> = ({ context }) => (
  <Accordion disableGutters elevation={0} sx={{ border: '1px solid #E7E7E7', borderRadius: '8px', '&:before': { display: 'none' } }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Box sx={{ fontSize: 13, fontWeight: 600 }}>
        Автоматично зібрано{context.errors.length ? ` · ${context.errors.length} помилок` : ''}
      </Box>
    </AccordionSummary>
    <AccordionDetails>
      <Box sx={{ fontSize: 12.5, fontFamily: 'monospace' }}>
        {ROW.map(([k, label]) => (
          <Box key={k} sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
            <Box sx={{ color: '#7A7F88', minWidth: 72 }}>{label}</Box>
            <Box sx={{ wordBreak: 'break-all' }}>{String(context[k])}</Box>
          </Box>
        ))}
        {context.errors.length > 0 && (
          <Box sx={{ mt: 1, pt: 1, borderTop: '1px solid #E7E7E7' }}>
            {context.errors.map((e, i) => (
              <Box key={i} sx={{ color: '#E2330A', wordBreak: 'break-all', mb: 0.5 }}>{e}</Box>
            ))}
          </Box>
        )}
      </Box>
    </AccordionDetails>
  </Accordion>
);

export default ContextAccordion;
